import { Close } from '@volkswagen-onehub/icons-core';
import { ReactNode } from 'react';
import Box from '../../Box/Box';
import { IconWrapper, StyledOverlayHeader } from '../FullScreenOverlay.styles';

interface OverlayHeaderProps {
  handleClose(): void;
  children?: ReactNode;
  headerBorder?: boolean;
}

const OverlayHeader = ({
  handleClose,
  children,
  headerBorder = true,
}: OverlayHeaderProps) => {
  return (
    <StyledOverlayHeader border={headerBorder}>
      <Box>{children}</Box>
      <IconWrapper onClick={handleClose}>
        <Close />
      </IconWrapper>
    </StyledOverlayHeader>
  );
};

export default OverlayHeader;
